import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconShareAudio } from '../../../base/icons/svg';
import MeetHourJS from '../../../base/lib-meet-hour';
import { isLocalParticipantModerator } from '../../../base/participants/functions';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { setOverflowMenuVisible } from '../../../toolbox/actions.web';
import { startAudioScreenShareFlow } from '../../actions.web';
import { isAudioOnlySharing, isScreenAudioSupported } from '../../functions';
/**
 * Component that renders a toolbar button for toggling audio only screen share.
 */
class ShareAudioButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.shareaudio';
        this.icon = IconShareAudio;
        this.label = 'toolbar.shareaudio';
        this.tooltip = 'toolbar.shareaudio';
        this.toggledIcon = IconShareAudio;
        this.toggledLabel = 'toolbar.stopAudioSharing';
    }
    /**
     * Handles clicking / pressing the button, and opens a new dialog.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(startAudioScreenShareFlow());
        dispatch(setOverflowMenuVisible(false));
    }
    /**
     * Indicates whether this button is in toggled state or not.
     *
     * @override
     * @protected
     * @returns {boolean}
     */
    _isToggled() {
        return this.props._isAudioOnlySharing;
    }
}
/**
 * Maps part of the Redux state to the props of this component.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {IProps}
 */
function _mapStateToProps(state) {
    const isGuest = isLocalParticipantModerator(state) === false;
    const isModerator = isLocalParticipantModerator(state);
    const isScreenSharingSupported = MeetHourJS.isDesktopSharingEnabled() && isScreenAudioSupported();
    // Share Audio should only be available to moderators (not guests)
    const canShareAudio = isScreenSharingSupported && !isGuest && isModerator;
    return {
        _isAudioOnlySharing: Boolean(isAudioOnlySharing(state)),
        visible: canShareAudio
    };
}
export default translate(connect(_mapStateToProps)(ShareAudioButton));
